export const signIn = "/sign-in";
export const signUp = "/sign-up";
export const resetPassword = "/reset-password";
export const resendVerification = "/resend-verification";

export const help = "/help";

export const billing = "/billing";
export const paymentMethod = "/billing/payment-method";
export const usageLimit = "/billing/usage-limit";

// DEVELOPER
export const developerDashboard = "/developer/dashboard";
// Developer - Usage
export const developerUsage = "/usage";
// Developer - keys
export const developerApiKeys = "/api-keys";
export const developerApiKeysEditKey = "/developer/api-keys/edit-key/:keyName";
export const developerApiDocs = "https://api-docs.geoscape.com.au/";

export const geoscapeDocumentation =
  "https://docs.geoscape.com.au/en/stable/index.html";

// DOCS
export const docsPage = "/documentation";
export const docsPreRelease =
  "https://docs.geoscape.com.au/en/stable/prerelease_reports.html";

export const docsApi = "https://api-docs.geoscape.com.au";
// DATA
export const dataDashboard = "/data/dashboard";
export const dataExplorer = "/explorer";
export const clipUi = "/clip/clip-ui";
export const clipManagement = "/clip/clip-management";

//DEMOS
export const demosPage = "/demos";
export const emissionsMetric = "/demos/emissions-metric";
export const nabLandUse = "/demos/nab-land-use";
export const nabDeforestation = "/demos/nab-vegetation";
export const vegetationChange = "/demos/vegetation-change";
export const floodDataDemo = "/demos/flood-data-demo";
export const predictiveAddress = "/demos/predictive-address";
export const predictiveLocality = "/demos/predictive-locality";
export const easements = "/demos/easements";
export const propertyInsights = "/demos/property-insights";
export const chatswoodBuildings = "/demos/chatswood-buildings";
export const nationalBuildingsChatswood = "/demos/national-buildings-chatswood";
export const electricityMarket = "/demos/electricity-market";
export const agriculturalLulc = "/demos/lulc-carrathool";

export const dataCatalogue = "/catalogue";
export const dataCatalogueEntry = "/catalogue/:productName";
export const dataDownload = "/datasets/download";
export const dataCustomDownload = "/datasets/custom-download";
export const dataTailor = "/data/tailor";

export const notFound = "/dashboard";
export const errors = "/usage/errors";

export const welcomeBack = "/welcome-back";
// export const legal = "/legal"

// Geoscape Hub
export const hub = "/hub";
export const whatsNew = "/whats-new";
export const article = "/whats-new/:slug";

// Settings
export const settings = "/settings";
//  Organisation Settings
export const orgGeneralSettings = "/settings/organisation/general-settings";
export const orgMembers = "/settings/organisation/members";
export const orgSubscription = "/settings/organisation/subscription";

export const orgFeatureComparisonTable =
  "/settings/organisation/subscription/feature-comparsion-table";

export const orgFeatureCostTable =
  "/settings/organisation/subscription/feature-costs-table";

export const orgReceipts = "/settings/organisation/receipts";
export const orgBillingDetails = "/settings/organisation/billing-details";
export const orgManageSubscription =
  "/settings/organisation/manage-subscription";

export const orgMemberDetails =
  "/settings/organisation/:orgId/members/:accountId";

//  User Settings
export const userPendingInvitations = "/settings/user/pending-invitations";
export const legal = "/legal";
export const userSecurity = "/settings/user/security";
export const userGeneralSettings = "/settings/user/general-settings";

// Admin
export const admin = "/admin";
export const adminDashboard = "/admin/dashboard";

// Admin Org Management
export const adminOrganisations = "/admin/organisations";
export const adminOrganisationDetails =
  "/admin/organisations/:organisationId/:tab";
export const adminOrganisationDetailsSubTab =
  "/admin/organisations/:organisationId/:tab/:subTab";
export const adminOrganisationDetailsSubTabEdit =
  "/admin/organisations/:organisationId/:tab/:subTab/:subTabId";

export const adminOrgMembers = "/admin/organisation/:organisationId/members";
export const adminApps = "/admin/organisations/:organisationId/apps";

export const adminUser = "/admin/management/user";

export const adminCreateApiKey =
  "/admin/organisations/:organisationId/apps/create";

export const adminEditApiKey =
  "/admin/organisations/:organisationId/apps/:keyName";

// Admin User Management
export const adminUsers = "/admin/users";
export const adminUserDetails = "/admin/users/:accountId";
export const adminUserEmails = "/admin/users/:accountId/emails";

export const AdminMemberDetails =
  "/admin/organisations/:orgId/members/:accountId";

// Admin Release Management
export const adminReleases = "/admin/release-management";
export const adminEditRelease = "/admin/release-management/:releaseKey";
export const adminReleaseDatasets =
  "/admin/release-management/:releaseKey/datasets";

// Admin Reporting
export const adminClipReporting = "/admin/clip-reporting";

export const adminEmailReporting = "/admin/email-reporting";

export const adminDatasets = "/admin/datasets";
export const adminMergeAccounts = "/admin/management/merge-accounts";
export const adminMigrateKeys = "/admin/management/migrate-keys";

// Admin Reporting
export const adminCustomerUsage = "/admin/reporting/customer-usage";
export const adminOnDemand = "/admin/reporting/on-demand";
export const adminReceipts = "/admin/reporting/receipts";
export const adminBillingDetails = "/admin/reporting/billing-details";

// Admin Custom Datasets
export const adminViewCustomDatasets = "/admin/custom-datasets";

// Admin Demos
export const adminDemoManagement = "/admin/demo-management";
export const adminEditDemo = "/admin/demo-management/:adminDemoId";

// Endpoint for testing sentry error handling
export const testError = "/test/error";

// Batch
export const batchDashboard = "/batch/dashboard";
export const batchBatches = "/batch";
export const batchCreateBatch = "/batch/create";

// Sales Tools
export const salesTools = "/sales-tools";
export const salesToolsRuralSchedule =
  "/sales-tools/buildings-imagery-lifecycle-dashboard";
export const salesToolsOpportunities = "/sales-tools/opportunities";
export const salesToolsOpportunitiesCreate =
  "/sales-tools/opportunities/create-opportunity";
export const salesToolsOpportunitiesDetail = "/sales-tools/opportunities/:id";
export const salesToolsOpportunitiesEdit =
  "/sales-tools/opportunities/:id/edit";
